import React from "react";
import { Link } from "react-router-dom";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Chip,
    Container,
    Grid,
    Stack,
    Typography
} from "@mui/material";
import Seo from "../components/Seo";
import { BLOG_ARTICLE_LIST } from "../content/blogArticles";

const formatDate = (isoDate) => new Date(`${isoDate}T00:00:00Z`).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
});

export const BlogIndexPage = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 5 }}>
            <Seo
                title="StockMaid Blog - GPU Restock Guides & Price Tracking"
                description="Read GPU restock guides, pricing analysis, and buying tips based on StockMaid tracking data."
                canonicalPath="/blog"
            />

            <Box sx={{ mb: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom sx={{ color: "var(--sm-heading-color)" }}>
                    StockMaid Blog
                </Typography>
                <Typography variant="body1" color="text.primary" sx={{ maxWidth: 700 }}>
                    Restock strategy, pricing analysis, and Best Buy buying workflows for high-demand NVIDIA GPUs.
                </Typography>
            </Box>

            <Grid container spacing={3}>
                {BLOG_ARTICLE_LIST.map((article) => (
                    <Grid item xs={12} sm={6} md={4} key={article.slug}>
                        <Card
                            component={Link}
                            to={`/blog/${article.slug}`}
                            sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                textDecoration: "none",
                                color: "inherit",
                                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    boxShadow: 6,
                                },
                                cursor: "pointer",
                            }}
                        >
                            {article.featuredImage && (
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={article.featuredImage}
                                    alt={article.title}
                                    sx={{ objectFit: "cover" }}
                                />
                            )}
                            <CardContent sx={{ flexGrow: 1 }}>
                                {article.tags && article.tags.length > 0 && (
                                    <Stack direction="row" spacing={0.5} sx={{ mb: 1.5 }} flexWrap="wrap" useFlexGap>
                                        {article.tags.slice(0, 2).map((tag) => (
                                            <Chip
                                                key={tag}
                                                label={tag}
                                                size="small"
                                                variant="outlined"
                                                sx={{ fontSize: "0.7rem" }}
                                            />
                                        ))}
                                    </Stack>
                                )}
                                <Typography variant="h6" component="h2" sx={{ mb: 1, lineHeight: 1.3 }}>
                                    {article.title}
                                </Typography>
                                <Typography variant="body2" color="text.primary" sx={{ mb: 1.5 }}>
                                    {formatDate(article.updatedAt)}
                                    {article.readTime && ` · ${article.readTime}`}
                                </Typography>
                                <Typography variant="body2" color="text.primary" sx={{ lineHeight: 1.5 }}>
                                    {article.description}
                                </Typography>
                            </CardContent>
                            <CardActions sx={{ px: 2, pb: 2 }}>
                                <Button component="span" variant="contained" size="small">
                                    Read article
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};
